import * as React from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { FileManagementFile } from "../../Interfaces/fileManagementFile";
import { createFileManagementFieldModel } from "../utils/createFileManagementFieldModel";

export const useUploads = (name: string) => {
  const [uploads, setUploads] = React.useState<FileManagementFile[]>([]);
  const { setValue } = useFormContext();
  const currentValue = useWatch({ name: name });
  React.useEffect(() => {
    if (uploads.length > 0) {
      setValue(name, createFileManagementFieldModel(uploads, currentValue?.files ?? []), {
        shouldValidate: true
      });
      setUploads([]);
    }
  }, [uploads, name, currentValue]);

  return {
    addUploadedFile: (file: FileManagementFile) => {
      setUploads((current) => [...current, file]);
    }
  };
};
